import type { TimelineElement } from '../types/timelineElement'

export type ResolvedNodeBinding = {
  id: string
  title: string
  color: string | null
  progress: number
}

export const resolveBindingFromElements = (
  linkedNodeId: string | null,
  elements: TimelineElement[],
): ResolvedNodeBinding | null => {
  if (!linkedNodeId) return null
  const match = elements.find((element) => element.id === linkedNodeId)
  if (!match) return null
  return {
    id: match.id,
    title: match.title,
    color: match.color ?? null,
    progress: typeof match.progress === 'number' ? match.progress : 0,
  }
}

export const buildBindingIndex = (elements: TimelineElement[]): Map<string, ResolvedNodeBinding> => {
  const index = new Map<string, ResolvedNodeBinding>()
  for (const element of elements) {
    index.set(element.id, {
      id: element.id,
      title: element.title,
      color: element.color ?? null,
      progress: typeof element.progress === 'number' ? element.progress : 0,
    })
  }
  return index
}
